/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tier_AddInputs */

const vi_shop_tier_add = /** @type {(inputs: Shop_Tier_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm hạng`)
};

/**

* @param {Shop_Tier_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_add = /** @type {((inputs?: Shop_Tier_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_add(inputs)
});